import { transformCurrencyAmountDto } from 'data/transformers/currency-amount'

import {
  AvailablePickupPointDto,
  NearbyShippingPointDto,
  NearbyShippingPointDetailDto,
  NearbyShippingOptionDto,
  AvailablePickupPointLastMileCarrierDto,
} from '../types/dtos/available-pickup-point'
import {
  NearbyShippingOptionModel,
  NearbyShippingPointDetailModel,
  NearbyShippingPointModel,
  AvailablePickupPointModel,
  AvailablePickupPointLastMileCarrierModel,
} from '../types/models/available-pickup-point'

export const transformLastMileCarrierDto = ({
  id,
  code,
  name,
  icon_url,
}: AvailablePickupPointLastMileCarrierDto): AvailablePickupPointLastMileCarrierModel => ({
  id,
  code,
  name,
  iconUrl: icon_url,
})

export const transformNearbyShippingOptionDto = ({
  title,
  last_mile_carrier,
  value_proposition,
  price,
}: NearbyShippingOptionDto): NearbyShippingOptionModel => ({
  title,
  lastMileCarrier: transformLastMileCarrierDto(last_mile_carrier),
  valueProposition: value_proposition,
  price: transformCurrencyAmountDto(price),
})

export const transformNearbyShippingPointDetailDto = ({
  code,
  address_line1,
  address_line2,
  name,
  carrier_code,
  city,
  postal_code,
}: NearbyShippingPointDetailDto): NearbyShippingPointDetailModel => ({
  code,
  addressLine1: address_line1,
  addressLine2: address_line2,
  name,
  carrierCode: carrier_code,
  city,
  postalCode: postal_code,
})

export const transformNearbyShippingPointDto = ({
  point,
}: NearbyShippingPointDto): NearbyShippingPointModel => ({
  point: transformNearbyShippingPointDetailDto(point),
})

export const transformAvailablePickupPointDto = ({
  nearby_shipping_options,
  nearby_shipping_points,
  suggested_shipping_point_code,
}: AvailablePickupPointDto): AvailablePickupPointModel => ({
  nearbyShippingOptions: nearby_shipping_options.map(transformNearbyShippingOptionDto),
  nearbyShippingPoints: nearby_shipping_points.map(transformNearbyShippingPointDto),
  suggestedShippingPointCode: suggested_shipping_point_code,
})
